<template>
    <div style="background-color:#f7f8fa">
        <van-nav-bar
            :title="title"
            left-text="返回"
            left-arrow
            @click-left="onClickLeft"
            />
        <a-card :title="'会议名称：'+item.meetingName" :bordered="false" style="width: 95%;margin:2.5% 2.5% 0 2.5%;font-size:14px" v-if="type.startsWith('meeting')">
            <p slot="extra" style="color:#52c41a">{{status}}</p>
            <div class="item">
                <p>会议时间：</p>
                <div class="text">{{item.startTime.substr(0,16)}}至{{item.endTime.substr(0,16)}}</div>
            </div>
            <div class="item">
                <p>会议室：</p>
                <div class="text">{{item.roomId}}</div>
            </div>
            <div class="item">
                <p>预约人：</p>
                <div class="text">{{item.orderPeople}}({{item.orderPeoplePhone}})</div>
            </div>
            <div class="item">
                <p>申请时间：</p>
                <div class="text">{{item.createTime}}</div>
            </div>
        </a-card>
        <a-card :bordered="false" style="width: 95%;margin:2.5% 2.5% 0 2.5%;font-size:14px" v-if="type.startsWith('meeting')">
            <van-steps direction="vertical" :active="active">
                <van-step>
                    <p style="font-weight:bold">申请-{{item.createTime}}</p>
                    <div class="item">
                        <p>参会人数：</p>
                        <div class="text">{{item.peopleNum}}</div>
                    </div>
                    <div class="item">
                        <p>备注：</p>
                        <div class="text">{{item.remark}}</div>
                    </div>
                </van-step>
                <van-step>
                    <p style="font-weight:bold">审批<span v-if="this.status == '办结'">-{{item.approveTime}}</span></p>
                    <div style="margin-top:10px">
                        <div class="item" v-if="this.status == '办结'">
                            <p>审批人：</p>
                            <div class="text">{{item.approver}}</div>
                        </div>
                        <div class="item" v-if="this.status == '办结'">
                            <p>审批意见：</p>
                            <div class="text">{{item.approvalComments}}</div>
                        </div>
                        <div v-if="this.type == 'meetingTodo'">
                            <a-textarea placeholder="请输入审批意见" v-model="approveComments" :auto-size="{ minRows: 5, maxRows: 8 }" />
                            <div class="btn-group">
                                <van-button type="warning" @click="meetingApprove(item.id,'2')" style="width:30%;">驳回</van-button>
                                <van-button type="primary" @click="meetingApprove(item.id,'1')" style="width:30%;margin-left:auto">通过</van-button>
                            </div>
                        </div>
                    </div>
                </van-step>
            </van-steps>
        </a-card>

        <a-card :title="'用章事由：'+item.targetUse" :bordered="false" style="width: 95%;margin:2.5% 2.5% 0 2.5%;font-size:14px" v-if="type.startsWith('seal')">
            <p slot="extra" style="color:#52c41a">{{status}}</p>
            <div class="item">
                <p>用章类型：</p>
                <div class="text">{{item.type}}</div>
            </div>
            <div class="item">
                <p>申请人：</p>
                <div class="text">{{item.teacherName}}</div>
            </div>
            <div class="item">
                <p>申请日期：</p>
                <div class="text">{{item.createTime}}</div>
            </div>
        </a-card>
        <a-card :bordered="false" style="width: 95%;margin:2.5% 2.5% 0 2.5%;font-size:14px" v-if="type.startsWith('seal')">
            <van-steps direction="vertical" :active="active">
                <van-step>
                    <p style="font-weight:bold">申请-{{item.createTime}}</p>
                    <div class="item">
                        <p>主送单位：</p>
                        <div class="text">{{item.mainOrg}}</div>
                    </div>
                    <div class="item">
                        <p>材料份数：</p>
                        <div class="text">{{item.materialNumber}}</div>
                    </div>
                    <div class="item">
                        <p>附件：</p>
                        <div class="text">
                            <van-uploader v-model="fileList" multiple :show-upload='false' :deletable='false'/>
                        </div>
                    </div>
                    <div class="item">
                        <p>备注：</p>
                        <div class="text">{{item.remark}}</div>
                    </div>
                </van-step>
                <van-step>
                    <p style="font-weight:bold">审批<span v-if="this.status == '办结'">-{{item.passDate}}</span></p>
                    <div style="margin-top:10px">
                        <div class="item" v-if="this.status == '办结'">
                            <p>审批人：</p>
                            <div class="text">{{item.approverName}}</div>
                        </div>
                        <div class="item" v-if="this.status == '办结'">
                            <p>审批意见：</p>
                            <div class="text">{{item.approveComments}}</div>
                        </div>
                        <div v-show="this.type=='sealTodo'">
                            <a-textarea placeholder="请输入审批意见" v-model="approveComments" :auto-size="{ minRows: 5, maxRows: 8 }" />
                            <div class="btn-group">
                                <van-button type="warning" @click="sealApprove(item.id,'reject')" style="width:30%;">驳回</van-button>
                                <van-button type="primary" @click="sealApprove(item.id,'approved')" style="width:30%;margin-left:auto">通过</van-button>
                            </div>
                        </div>
                    </div>
                </van-step>
            </van-steps>
        </a-card>
    </div>
</template>
<script>
import { sealTodo,meetingApply,meetingTodo,sealApply } from '@/baseAPI/mobile/mobile'
import { approve as meetingApprove} from '@/baseAPI/office/meetingRooms'
import { approve as sealApprove,info as sealInfo } from '@/baseAPI/undergraduate/culture/seal'
export default {
    name: '',
    data () {
        return {
            title:'',
            item:null,
            type:'',
            approveComments:'',
            status:'流程中',
            active:0,
            fileList: [],
        }
    },
    mounted () {
        this.type = this.$route.query.type;
        if(this.type == 'sealApply'){
            this.title = "用印-我的申请-详情"
            this.status = "流程中"
            this.sealInfo(JSON.parse(this.$route.query.item).id)
        }else if(this.type == 'sealApplyEnd'){
            this.title = "用印-我的申请-详情"
            this.status = "办结"
            this.active = 1
            this.sealInfo(JSON.parse(this.$route.query.item).id)
        }else if(this.type == 'meetingApply'){
            this.title = "会议室-我的申请-详情"
            this.status = "流程中"
            this.item = JSON.parse(this.$route.query.item);
        }else if(this.type == 'meetingApplyEnd'){
            this.title = "会议室-我的申请-详情"
            this.status = "办结"
            this.active = 1
            this.item = JSON.parse(this.$route.query.item);
        }else if(this.type == 'sealTodo'){
            this.title = "用印-我的审批-详情"
            this.status = "流程中"
            this.sealInfo(JSON.parse(this.$route.query.item).id)
        }else if(this.type == 'sealTodoEnd'){
            this.title = "用印-我的审批-详情"
            this.status = "办结"
            this.active = 1
            this.sealInfo(JSON.parse(this.$route.query.item).id)
        }else if(this.type == 'meetingTodo'){
            this.title = "会议室-我的审批-详情"
            this.status = "流程中"
            this.item = JSON.parse(this.$route.query.item);
        }else if(this.type == 'meetingTodoEnd'){
            this.title = "会议室-我的审批-详情"
            this.status = "办结"
            this.active = 1
            this.item = JSON.parse(this.$route.query.item);
        }
        console.log(this.item)
    },
    // beforeRouteEnter(to, from, next) {
    //     next(()=> {
    //         window.sessionStorage.setItem("lasterRouter", from.path)
    //     })
    // },
    methods:{
        sealInfo(id){
            sealInfo(id).then(res=>{
                this.item = res.data
                this.item.files.forEach(e => {
                    this.fileList.push({url:this.$store.state.axiosUrl+e.fileUrl,name:e.fileName})
                });
            })
        },
        onClickLeft(){
            // this.$router.push(window.sessionStorage.getItem("lasterRouter"))
            this.$router.go(-1)
        },
        sealApprove(id,status){
            sealApprove({id:id,approvalStatus:status,approveComments:this.approveComments}).then(res=>{
                if(res.data.success){
                    this.$notification['success']({
                        message: '成功',
                        description:'审批成功',
                    });
                    this.$router.go(-1)
                }else{
                    this.$notification['error']({
                        message: '失败',
                        description:res.data.errorMessage,
                    });
                }
            })
        },
        meetingApprove(id,status){
            meetingApprove({applyId:id,status:status,approvalComments:this.approveComments}).then(res=>{
                if(res.data.success){
                    this.$notification['success']({
                        message: '成功',
                        description:'审批成功',
                    });
                    this.$router.go(-1)
                }else{
                    this.$notification['error']({
                        message: '失败',
                        description:res.data.errorMessage,
                    });
                }
            })
        }
    }
}
</script>
<style scoped>
.item{
    display: flex;
}
.item p{
    text-align: right;
    width: 70px;
}
.item .text{
    width: calc(100% - 70px);
}
.btn-group{
    width: 100%;
    margin-top: 10px;
    display:flex;
}
</style>
